define('common/urlUtils',[
],
    function () {

        // Takes the url and parses the query string parameters out of it.
        // Returns the parameters and their string values as object { paramName1: value1, paramName2: value2, ...},
        // or an empty object in case there are no parameters in url.
        function parseQueryParamsFromUrl(url) {
            url = url ? url : window.location.search; // default url parameter if not set
            // take just the query search part of url (lose the leading question mark)
            var query = decomposeUrl(url).search;
            if (query.indexOf("?") >= 0) query = query.substring(query.indexOf("?") + 1);
            var urlParams = {},
                match,
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) { return decodeURI(decodeURIComponent(s)); };

            while (match = search.exec(query))
                urlParams[decode(match[1])] = decode(match[2]);

            return urlParams;
        }

        // Takes the url, decomposes it into three components: path, search, hash,
        // and returns those three components in an object.
        // When searching for hash string which is directly after path (without search parameters) we're ignoring '#/'.
        // That is not a hash, that is Angular routing and it's actually part of the path.
        function decomposeUrl(url) {
            var path = '';
            var search = '';
            var hash = '';
            if (url.indexOf('?') >= 0) {
                // there is search string already in the url
                path = url.substring(0, url.indexOf('?'));
                search = url.substring(url.indexOf('?'));
                if (search.indexOf('#') >= 0) {
                    // there is also a hash string in the url
                    hash = search.substring(search.indexOf('#'));
                    search = search.substring(0, search.indexOf('#'));
                }
            } else if (url.indexOf('#') >= 0 && url.indexOf('#') != url.indexOf('#/')) {
                // no search string, but there is hash string
                path = url.substring(0, url.indexOf('#'));
                hash = url.substring(url.indexOf('#'));
            } else {
                // no search string, no hash string
                path = url ? url : '';
            }
            return {
                path: path,        // path also includes the protocol and hostname (if they existed in the given url)
                search: search,
                hash: hash
            }
        }

        // Adds a new query string parameter into the given url.
        // Returns the newly constructed url.
        function putParamIntoUrl(paramName, paramValue, url) {
            // first we'll split the url into 3 components
            var urlComp = decomposeUrl(url);
            // add the new query string parameter into search string
            urlComp.search = (urlComp.search ? urlComp.search + '&' : '?') + paramName + '=' + encodeURIComponent(paramValue);
            // return the new url
            return urlComp.path + urlComp.search + urlComp.hash;
        }

        // Reads the specified query string parameter from a given url.
        // Returns the value of that parameter (a string value). 
        function getParamFromUrl(paramName, url) {
            return parseQueryParamsFromUrl(url)[paramName];
        }

        // Modifies the given DOM element's href property, or the current page's URL (if
        // no domElement has been given) by adding new query string parameter with the
        // given value. 
        function pushParamIntoLink(paramName, paramValue, domElement) {
            var url;
            if (domElement) url = $(domElement).attr('href');    // url from DOM element
            else url = window.location.href;                    // current page url

            var params = parseQueryParamsFromUrl(url);

            // making sure that we find the parameter no matter how it's written (case insensitive)
            for (var p in params) {
                if (p.toLowerCase() === paramName.toLowerCase()) {
                    paramName = p;
                    break;
                }
            }

            params[paramName] = paramValue;           // update (or add) the parameter
            var newSearchString = $.param(params);    // and construct a new search string.

            var urlComp = decomposeUrl(url);
            if (domElement) {
                // set new href property on DOM element
                var newHref = urlComp.path + (newSearchString ? ('?' + newSearchString) : '') + urlComp.hash;
                $(domElement).attr('href', newHref);
            } else {
                if (history && history.pushState) {      // because some older browsers (IE 9 or older) don't support this
                    // for other pages put new URL to browser's address bar using window.history
                    history.replaceState(
                        null,
                        null,
                        urlComp.path +
                        (newSearchString ? ('?' + newSearchString) : '') +
                        urlComp.hash
                    );
                }
            }
        }

        // Reads the query string parameter from the domElement's href property, or from
        // the current page's URL (if no domElement has been given). Removes the parameter
        // from the URL and puts new URL into the domElement's href property, or into the
        // browser's address bar.
        // Returns the value of that parameter (a string value).
        function popParamFromLink(paramName, domElement) {
            var url;
            if (domElement) url = $(domElement).attr('href');    // url from DOM element
            else url = window.location.href;                    // current page url

            var params = parseQueryParamsFromUrl(url);
            var retVal;

            // making sure that we find the parameter no matter how it's written (case insensitive)
            for (var p in params) {
                if (p.toLowerCase() === paramName.toLowerCase()) {
                    paramName = p;
                    break;
                }
            }

            if (params[paramName]) {
                // the requested parameter exists in the url
                retVal = params[paramName];    // Its value will be returned from the function.
                delete params[paramName];      // Remove the parameter from the array,
                var newSearchString = $.param(params);    // and construct a new search string.
                var urlComp = decomposeUrl(url);
                if (domElement) {
                    // set new href property on DOM element
                    var newHref = urlComp.path + (newSearchString ? ('?' + newSearchString) : '') + urlComp.hash;
                    $(domElement).attr('href', newHref);
                } else {
                    if (history && history.pushState) {      // because some older browsers (IE 9 or older) don't support this
                        // for other pages put new URL to browser's address bar using window.history
                        history.replaceState(
                            null,
                            null,
                            urlComp.path +
                            (newSearchString ? ('?' + newSearchString) : '') +
                            urlComp.hash
                        );
                    }
                }
            }
            return retVal;
        }


        return {
            parseQueryParamsFromUrl: parseQueryParamsFromUrl,
            decomposeUrl: decomposeUrl,
            putParamIntoUrl: putParamIntoUrl,
            getParamFromUrl: getParamFromUrl,
            pushParamIntoLink: pushParamIntoLink,
            popParamFromLink: popParamFromLink
        }
    });

